import { RegistryType } from "../../backend-definitions.module";
import { ContactList } from "../../others/contact-list";
import { Address } from "../../tables/address/address";
import { ImageObj } from "./../../interface/image-obj";
import { CostCenter } from "./cost-center";
import { Shift } from "./shift";

export class Company {
    id: number;
    name: string;
    image: ImageObj;
    tradeName: string;
    alias: string;
    active: boolean;
    unity: boolean;
    issuingEntity: string;
    registryType: RegistryType;
    cnpj: string;
    cnes: string;
    address: Address;
    contactList: ContactList;
    companyParent: Company;
    costCenterList: CostCenter[];
    shiftList: Shift[];
    constructor() {}
}

export class CompanyCostCenter {
    id: number;
    company: Company;
    costCenter: CostCenter;
}

export class CompanySusServiceClassification {
    id?: number;
    company?: Company;
    service_code?: string;
    classification_code?: string;
}
